export default class BindInstance {
  id: string;

  code: string;

  description: string;

  active: boolean;

  startedAt: string;

  startedAtChangeConfirmed: boolean;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.code = obj.code || '';
    this.description = obj.description || '';
    this.active = obj.active === undefined ? true : obj.active;
    this.startedAt = obj.startedAt || new Date().toISOString().substring(0, 10);
    this.startedAtChangeConfirmed = obj.startedAtChangeConfirmed || false;
  }

  public static of(obj: any): BindInstance {
    return new BindInstance(obj);
  }

  public static ofList(obj: any[]): BindInstance[] {
    return obj.map(this.of)
  }

  get status(): string {
    return this.active ? 'ativo' : 'inativo';
  }

  get isNew(): boolean {
    return this.id === '' && this.code === '' && this.description === '';
  }

  get isAlreadyVinculatedWithInactiveStatus(): boolean {
    return !this.isNew && !this.active;
  }

  get isActive(): boolean {
    return this.active;
  }
}
